<template>
  <div id="app" v-bind:class="[{showMenu: showMenu}, lang]">
    <div class="view-container" @click="closeMenu">
      <transition name="slide">
        <router-view v-on:closeMenu="closeMenu" v-on:openMenu="openMenu"/>
      </transition>
    </div>
    <div class="menu-container">
      <menu-content :closeMenu="closeMenu"></menu-content>
    </div>
  </div>
</template>

<script>

import MenuContent from "./components/MenuContent";

export default {
  name: 'App',
  components: {
    MenuContent
  },
  data() {
    return{
      showMenu: false
    }
  },
  mounted(){
    window.addEventListener('resize', () => {
      this.$store.commit('setMobile', window.outerWidth < 768 )
    })
  },
  computed: {
    lang (){
      return this.$i18n.locale
    }
  },
  methods: {
    closeMenu(){
      this.showMenu = false
    },
    openMenu(){
      this.showMenu = true
    }
  }

}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Noto+Sans:200,400,400i,700,700i');
//@import '~@/assets/fonts/noto-kufi/stylesheet';
@import '~@/assets/fonts/noto-sans/stylesheet';

body
  margin: 0;
  padding: 0;
  position relative

#app
  font-family: 'Noto Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display flex
  position relative
  overflow hidden
  height 100vh
  width 100%


#app.ar
  font-family: 'Noto Sans Arabic', Helvetica, Arial, sans-serif;
  text-align right 
  p, span, .paragraph, .par, h1, h2, h3, h4, .text-container, .advice
    direction rtl

#app .view-container
  min-width  100%
  max-width  100%
  box-shadow: 0pt -3pt 6pt rgba(0,0,0, 0.16);
  position absolute
  left 0
  top 0
  z-index 1
  transition: left .5s;
  max-height: 100vh;
  overflow: auto;

#app .menu-container
  background #fff
  width 250px
  position absolute
  left 100%
  top 0
  transition: left .5s;

#app.showMenu 
  .view-container
    left -250px
  .menu-container
    left calc(100% - 250px)
@media only screen and (min-width: 768px) {
  #app {
    text-align: left;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue